/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react';

import { graphql, StaticQuery } from 'gatsby';
import Helmet from 'react-helmet';

import styled, { createGlobalStyle } from 'styled-components';
import CookieConsent from 'react-cookie-consent';
import Carousel from './Carousel';
import MainMenu from './MainMenu';
import Footer from './Footer';
import './global.css';

const GlobalStyles = createGlobalStyle`
  body, html{
    font-family: 'Open Sans', sans-serif;
    margin: 0 !important;
    padding: 0 !important;
    background-color: #ffffff;
    color: #262423;
  }
`;

const CookiePolicy = styled.div`
  font-size: 11px;
`;

const LayoutWrapper = styled.div`
  max-width: 1020px;
  padding-left: 5px;
  padding-right: 5px;
  margin: 0 auto;
  padding-top: 100px;
  @media (min-width: 420px) and (min-height: 500px) {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 115px;
  }
  @media (min-width: 1500px) and (min-height: 500px) {
    max-width: 1200px;
  }
  @media (min-width: 1800px) and (min-height: 500px) {
    max-width: 1500px;
  }
  @media (min-width: 2200px) and (min-height: 500px) {
    max-width: 2000px;
  }
`;

const FAVICON_AND_COOKIE_POLICY_QUERY = graphql`
  {
    allWordpressWpFavicon {
      edges {
        node {
          url {
            source_url
          }
        }
      }
    }
    allWordpressPage(filter: { title: { regex: "/Cookie/" } }) {
      edges {
        node {
          content
        }
      }
    }
  }
`;

const Layout = ({ categorisedMedia, children }) => (
  <div>
    <GlobalStyles />
    <StaticQuery
      query={FAVICON_AND_COOKIE_POLICY_QUERY}
      render={(props) => (
        <div>
          <Helmet>
            <link
              rel="icon"
              href={props.allWordpressWpFavicon.edges[0].node.url.source_url}
            />
          </Helmet>
          <CookieConsent
            location="bottom"
            buttonText="Accept"
            declineButtonText="Decline"
            cookieName="gatsby-gdpr-google-analytics"
            enableDeclineButton
            flipButtons
            style={{ background: '#262423' }}
          >
            <CookiePolicy
              dangerouslySetInnerHTML={{
                __html: props.allWordpressPage.edges[0].node.content,
              }}
            />
          </CookieConsent>
        </div>
      )}
    />
    <MainMenu />
    <LayoutWrapper>
      {children}
      <Carousel categorisedMedia={categorisedMedia || []} />
    </LayoutWrapper>
    <Footer />
  </div>
);

export default Layout;
